module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sider panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("发布新话题")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("小贴士")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._v("本站是开源的哦，访问 http://gethomeland.com 获得更多信息")])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("推荐Ruby资源")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "sider-ul"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/wiki/ruby-mirror"
    }
  }, [_vm._v("Ruby 镜像")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gems.ruby-china.org",
      "target": "_blank"
    }
  }, [_vm._v("RubyGems 镜像")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://railscasts.com",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_vm._v("Rails 视频教程")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://guides.ruby-china.org"
    }
  }, [_vm._v("Rails Guides 中文版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://railstutorial-china.org"
    }
  }, [_vm._v("Ruby on Rails 教程")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("友情社区")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "sider-ul"
  }, [_c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://cnodejs.org",
      "rel": "nofollow",
      "title": "CNode 社区",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "1",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/d427ef3efd33b57721df152c2aa1735e.png"
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://golangtc.com/",
      "rel": "nofollow",
      "title": "Golang 中国",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "2",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/3b0fc569b40157a397143d121fea7e6f.png"
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://laravel-china.org",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "3",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/d7782871f3fac7e85a95d20c74046909.png"
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://elixir-cn.com",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "4",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2015/f65fb5a10d3392a1db841c85716dd8f6.png"
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://ionichina.com/",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "5",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/62e5d33d4f90ead9e798e3f8ae085f16.png"
    }
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://testerhome.com/",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "alt": "6",
      "src": "//ruby-china-files.b0.upaiyun.com/photo/2016/5cd78b730062ab3c768bcc2592c5c7fa.png"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("统计信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "sider-ul"
  }, [_c('li', [_vm._v("社区会员: 30232 人")]), _vm._v(" "), _c('li', [_vm._v("帖子数: 32156 个")]), _vm._v(" "), _c('li', [_vm._v("回帖数: 313960 条")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b663446!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Sider.vue
// module id = 281
// module chunks = 6